import Component from '../app/component.js';
import sessionDocuments from '../plugins/session-documents.js';
import salesforce from '../plugins/salesforce.js';
import dateformat from 'dateformat';
import events from '../plugins/events.js';

export default class extends Component {
  constructor (el) {
    super(el);
    this.data = {
      errors: [],
      errorMailMessage: false,
      successMessage: false,
      privacyChecked: false,
      newsletterChecked: null,
      commercialChecked: null
    };
  }

  init() {
    // toggle event
    document.addEventListener('requestoverlay.toggle', () => this.toggle());
    this.refs.addMoreButton.addEventListener('click', () => this.toggle());
    sessionDocuments.addListener(() => this.updateList());
    this.updateList();

    setTimeout(() => this.el.classList.add(this.el.dataset.classActive), 100);

    if (this.refs.privacyCheckbox) {
      this.refs.privacyCheckbox.addEventListener('click', () => {
        this.data.privacyChecked = !this.data.privacyChecked;
      });
    }

    if (this.refs.newsletterCheckbox?.length) {
      this.refs.newsletterCheckbox.forEach(el => {
        el.addEventListener('click', () => {
          const value = el.getAttribute('data-value') === '1' ? true : false;
          this.data.newsletterChecked = value;
        });
      });
    }

    if (this.refs.commercialCheckbox) {
      this.refs.commercialCheckbox.forEach(el => {
        el.addEventListener('click', () => {
          const value = el.getAttribute('data-value') === '1' ? true : false;
          this.data.commercialChecked = value;
        });
      });
    }

    // auto add file to sessionDocuments
    if (this.el.getAttribute('data-add-id') && this.el.getAttribute('data-add-title')) {
      const id = this.el.getAttribute('data-add-id');
      const title = this.el.getAttribute('data-add-title');
      const type = this.el.getAttribute('data-add-type').replace(/&/g, '&amp;');
      sessionDocuments.add({ id, title, type });
      this.data.successMessage = true;
      setTimeout(() => this.toggle(), 100);
    }

    // submit form
    this.refs.form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (this.validateForm()) {
        this.disableSubmitButton();
        this.submit();
      }
      return false;
    });

    this.refs.countryField.addEventListener('change', () => {
      if (this.refs.countryField.value) {
        this.refs.countryField.dataset.active = '';
      }
      else {
        delete this.refs.countryField.dataset.active;
      }
    });
  }

  toggle() {
    this.updateList();
    if (this.el.classList.contains('requestoverlay--active')) {
      this.el.classList.remove('requestoverlay--active');
      document.body.classList.remove('layout-unscrollable');
      events.emit('requestoverlay.hidden');
      this.enableSubmitButton();
    }
    else {
      this.el.classList.add('requestoverlay--active');
      document.body.classList.add('layout-unscrollable');
      events.emit('requestoverlay.display');
    }
  }

  submit() {
    const headers = new Headers();
    const body = new FormData();
    const documents = sessionDocuments.get();

    if (!documents.length) {
      this.enableSubmitButton();
      return;
    }

    const chemistry = documents.reduce(
      (value, item) => {
        if (value === 'Both') {
          return value;
        }
        if (!value) {
          return item.type;
        }
        if (value !== item.type) {
          return 'Both';
        }
        return value;
      },
      null
    );


    headers.append('Authorization', `Basic ${btoa('api@luglio7.com:w~,,V&"2=UMaq3C@')}`);
    body.append('firstName', this.refs.firstNameField.value);
    body.append('lastName', this.refs.lastNameField.value);
    body.append('email', this.refs.emailField.value);
    body.append('company', this.refs.companyField.value);
    body.append('country', this.refs.countryField.value);
    body.append('privacy', this.refs.privacyField.checked);
    body.append('newsletter', this.refs.newsletterField.checked);
    body.append('commercial', this.refs.commercialField.checked);
    body.append('message', this.refs.messageField.value);
    body.append('chemistry', chemistry);
    body.append('documents', documents.map(doc => doc.id).join(','));

    fetch(
      '/api/sovema/sendemail',
      {
        method: 'POST',
        headers,
        body
      }
    )
      .then(res => res.json())
      .then(data => {
        if (data.mailSent) {
          if (window.location.hostname !== 'sovema-files.local') {
            salesforce.salesForceSubmit({
              email: this.refs.emailField.value,
              company: this.refs.companyField.value,
              firstName: this.refs.firstNameField.value,
              lastName: this.refs.lastNameField.value,
              country: this.refs.countryField.value,
              url: window.location.href,
              privacyAcceptanceDate: dateformat(new Date(), 'dd/mm/yyyy HH.MM'),
              touchPointDate: dateformat(new Date(), 'dd/mm/yyyy HH.MM'),
              touchPointName: window.__lead ? `Inbound Machine - ${window.__lead}` : 'Inbound Machine',
              touchPointAction: 'Richiesta download',
              touchPointSubject: documents.map(doc => doc.title).join(', '),
              touchPointMessage: this.refs.messageField.value,
              emailOptOut: this.refs.newsletterField.checked ? "0" : "1",
              leadSource: window.__lead ? `Inbound Machine - ${window.__lead}` : 'Inbound Machine',
              newsletter: this.refs.newsletterField.checked ? 'Subscribed' : 'Not confirmed',
              chemistry: chemistry
            }).then(() => {
              window.location.href = `${window.__homeUrl}/mailsent:1`;
            });
          }
          else {
            window.location.href = `${window.__homeUrl}/mailsent:1`;
          }

          this.enableSubmitButton();
          this.clearForm();
          this.toggle();
          sessionDocuments.clear();
        } else {
          this.enableSubmitButton();
          this.data.errorMailMessage = true;
        }
      })
      .then(() => { })
      .catch(err => {
        this.enableSubmitButton();
        console.warn(err);
      });
  }

  disableSubmitButton() {
    this.refs.submit.disabled = true;
  }

  enableSubmitButton() {
    this.refs.submit.disabled = false;
  }

  clearForm() {
    this.refs.firstNameField.value = null;
    this.refs.lastNameField.value = null;
    this.refs.emailField.value = null;
    this.refs.countryField.value = null;
    this.refs.companyField.value = null;
    this.privacyChecked = false;
    this.newsletterChecked = null;
    this.commercialChecked = null;
  }

  validateForm() {
    const errors = [];

    if (!this.refs.firstNameField.value) {
      errors.push('firstNameField');
    }
    if (!this.refs.lastNameField.value) {
      errors.push('lastNameField');
    }
    if (!this.refs.emailField.value.match(/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i)) {
      errors.push('emailField');
    }
    if (!this.refs.privacyField.checked) {
      errors.push('privacyField');
    }
    if (!this.refs.countryField.value) {
      errors.push('countryField');
    }

    this.data.errors = errors;

    return errors.length === 0;
  }

  updateList() {
    const documents = sessionDocuments.get();

    // clear list
    while (this.refs.list.firstChild) {
      this.refs.list.removeChild(this.refs.list.firstChild);
    }

    if (!documents.length) {
      const li = this.refs.listTemplate.content.querySelector('li').cloneNode(true);
      const span = li.querySelector('span');
      li.removeChild(span);
      li.append('Empty list');
      this.refs.list.appendChild(li);
      return;
    }

    // append list items
    documents.forEach(doc => {
      const li = this.refs.listTemplate.content.querySelector('li').cloneNode(true);
      const span = li.querySelector('span');
      span.setAttribute('data-id', doc.id);
      span.setAttribute('data-title', doc.title);
      li.addEventListener('click', () => sessionDocuments.remove(doc.id));
      li.prepend(doc.title);
      this.refs.list.appendChild(li);
    });
  }

  watchErrors(value) {
    ["firstNameField", "lastNameField", "emailField", "companyField", "privacyField", "countryField"].forEach(key => {
      if (this.refs[key]) {
        this.refs[key].parentNode.classList.remove("ui-form-field--error");
      }
    });
    value.forEach(key => {
      this.refs[key].parentNode.classList.add("ui-form-field--error");
    });
  }

  watchPrivacyChecked(value) {
    if (this.refs.privacyCheckbox && this.refs.privacyField) {
      if (value) {
        this.refs.privacyField.checked = true;
        this.refs.privacyCheckbox.classList.add('ui-form-checkbox--active');
      } else {
        this.refs.privacyField.checked = false;
        this.refs.privacyCheckbox.classList.remove('ui-form-checkbox--active');
      }
    }
  }

  watchNewsletterChecked(value) {
    if (this.refs.newsletterCheckbox && this.refs.newsletterField) {
      if (value === true) {
        this.refs.newsletterField.checked = true;
        this.refs.newsletterCheckbox[0].classList.add('ui-form-checkbox--active');
        this.refs.newsletterCheckbox[1].classList.remove('ui-form-checkbox--active');
      }
      if (value === false) {
        this.refs.newsletterField.checked = false;
        this.refs.newsletterCheckbox[0].classList.remove('ui-form-checkbox--active');
        this.refs.newsletterCheckbox[1].classList.add('ui-form-checkbox--active');
      }
    }
  }

  watchCommercialChecked(value) {
    if (this.refs.commercialCheckbox && this.refs.commercialField) {
      if (value === true) {
        this.refs.commercialField.checked = true;
        this.refs.commercialCheckbox[0].classList.add('ui-form-checkbox--active');
        this.refs.commercialCheckbox[1].classList.remove('ui-form-checkbox--active');
      }
      if (value === false) {
        this.refs.commercialField.checked = false;
        this.refs.commercialCheckbox[0].classList.remove('ui-form-checkbox--active');
        this.refs.commercialCheckbox[1].classList.add('ui-form-checkbox--active');
      }
    }
  }

  watchErrorMailMessage(value) {
    if (value) {
      this.refs.errorMessageEmail.classList.add('ui-message--active');
      setTimeout(() => this.data.errorMailMessage = false, 5000);
    } else {
      this.refs.errorMessageEmail.classList.remove('ui-message--active');
    }
  }

  watchSuccessMessage(value) {
    if (value) {
      this.refs.successMessage.classList.add('ui-message--active');
      setTimeout(() => this.data.successMessage = false, 5000);
    } else {
      this.refs.successMessage.classList.remove('ui-message--active');
    }
  }
}
